import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HydrogenWaterExplained } from './components/HydrogenWaterExplained';
import { ChallengeAndSolution } from './components/ChallengeAndSolution';
import { TransformationSection } from './components/TransformationSection';
import { About } from './components/About';
import { Implementation } from './components/Implementation';
import { BenefitsGrid } from './components/BenefitsGrid';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App" style={{ background: 'var(--bg-page)' }}>
      <Header />
      <Hero />
      <HydrogenWaterExplained />
      <ChallengeAndSolution />
      <TransformationSection />
      <About />
      <Implementation />
      <BenefitsGrid />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
